export interface IJispPayAccount {
    name: string;
    type: IJispPayAccountTypeEnum;
}

export enum IJispPayAccountTypeEnum {
    Vendor = 0,
    Staff = 1
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/jispPay/models/IJispPayAccount.ts